import React from 'react'
import { Field, reduxForm } from 'redux-form'
import TextInput from '../../containers/Forms/components/TextInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import ReactMultiSelectDropdownInput from '../../containers/Forms/components/ReactMultiSelectDropdownInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import { getName, getPrescriptionOptionLabel } from '../../containers/Utilities'
import {
  ALL_RECORDINGS_TRIGGER_OPTION,
  CUSTOM_TRIGGER_OPTION,
  getPrimaryTriggerOptions,
  TRIAGE_OPTION,
} from '../../constants'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import { requiredValidation, emailMask, emailValidation, minLen1Validation } from '../../containers/Forms/components/formValidations'
import styles from './Forms.css'
import Number1 from 'static/images/number-1.svg'
import Number2 from 'static/images/number-2.svg'
import Number3 from 'static/images/number-3.svg'
import Loading from '../../components/Loading'
import { filterPrescriptionCanBePrescribed, filterBillingCodesCanBeBillable } from '../../store/appReducer'

const PrescribeForm = props => {
  const {
    handleSubmit,
    prescribeFormData,
    physicians,
    prescriptions,
    triggers,
    invalid,
    pristine,
    submitting,
    billingCodes,
    icd10Codes,
    isSubmitting,
  } = props

  let physiciansOptions = [
    TRIAGE_OPTION,
  ]
  let prescriptionOptions = []
  let triggerOptions = []
  let billingOptions = []
  let icd10Options = []

  if (physicians && physicians.data) {
    physiciansOptions = [ ...physiciansOptions, ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id]) ]
  }

  if (prescriptions && prescriptions.data) {
    prescriptionOptions = [ ...prescriptionOptions, ...filterPrescriptionCanBePrescribed(prescriptions.data.source) ]
  }

  if (triggers && triggers.data) {
    triggerOptions = [ ...triggerOptions, ...getPrimaryTriggerOptions(triggers.data) ]
  }

  if (billingCodes && billingCodes.data) {
    billingOptions = [ ...billingOptions, ...filterBillingCodesCanBeBillable(billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])) ]
  }

  if (icd10Codes && icd10Codes.data) {
    icd10Options = [ ...icd10Options, ...icd10Codes.data.sortedByName.map(id => icd10Codes.data.byId[id]) ]
  }

  const isCustomSelected = prescribeFormData && prescribeFormData.ekgReviewWhichRecordings && prescribeFormData.ekgReviewWhichRecordings.id === CUSTOM_TRIGGER_OPTION.id
  let isPossibleAFibResultWithHrCheckmarked = false
  let isHeartRateUnderCheckmarked = false
  let isHeartRateOverCheckmarked = false
  let isIDTFPlanChecked = false

  if (prescribeFormData) {
    if (prescribeFormData.custom) {
      const {
        custom,
      } = prescribeFormData

      isPossibleAFibResultWithHrCheckmarked = custom.possibleAFibResultWithHrCheckmark
      isHeartRateUnderCheckmarked = custom.heartRateUnderCheckmark
      isHeartRateOverCheckmarked = custom.heartRateOverCheckmark
    }
    // Checking whether IDTF is true or not
    isIDTFPlanChecked = prescribeFormData.prescriptionPlan && prescribeFormData.prescriptionPlan.isIDTF
  }

  let idtfTemplate = true
  idtfTemplate = isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked

  return (
    <div className={styles.prescribeContainer}>
      <form onSubmit={handleSubmit}>
        <div className={styles.prescribeSection}>
          <h2>Connection Plan</h2>
          <div className={styles.label}>Select a Connection Plan for the Patient</div>
          <div className={styles.prescribeStep}>
            <span>Step</span>
            <Number1 />
          </div>
          <div className={styles.prescribeBorder}>
            <Field
              component={ReactSelectDropdownInput}
              name="prescriptionPlan"
              isLoading={prescriptions && prescriptions.isFetching}
              isClearable={false}
              backspaceRemovesValue={false}
              placeholder="Select a Connection Plan"
              options={prescriptionOptions}
              noOptionsMessage="No connection plan found"
              getOptionLabel={getPrescriptionOptionLabel}
              getOptionValue={p => p.id}
              validate={requiredValidation}
            />
            <Field
              component={MaskedInput}
              mask={emailMask}
              placeholder="Enter Patient Email Address"
              name="email"
              validate={idtfTemplate ? '' : [ emailValidation, minLen1Validation, requiredValidation ]}
            />
          </div>
        </div>
        <div className={styles.prescribeSection}>
          <h2>Reports & Billing</h2>
          <div className={styles.label}>Designate Billing Codes to Generate Reports</div>
          <div className={styles.prescribeStep}>
            <span>Step</span>
            <Number2 />
          </div>
          <div className={styles.prescribeBorder}>
            {/* MultiSelect Dropdown in case of IDTF */}
            {isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked ?
              <React.Fragment>
                <Field
                  component={ReactMultiSelectDropdownInput}
                  name="icd10Codes"
                  enableSearch={true}
                  selected={icd10Codes}
                  isLoading={icd10Codes && icd10Codes.isFetching}
                  placeholder="Select ICD-10 Code"
                  options={icd10Options}
                  noOptionsMessage="No codes found"
                  getOptionLabel={p => {
                    let label = p.id
                    if (p.name) {
                      label += ` - ${p.name}`
                    }
                    return label
                  }}
                  getOptionValue={p => p.id}
                />
              </React.Fragment> :
              <Field
                component={ReactSelectDropdownInput}
                name="icd10Codes"
                isLoading={icd10Codes && icd10Codes.isFetching}
                placeholder="Select ICD-10 Code"
                options={icd10Options}
                noOptionsMessage="No codes found"
                getOptionLabel={p => {
                  let label = p.id
                  if (p.name) {
                    label += ` - ${p.name}`
                  }
                  return label
                }}
                getOptionValue={p => p.id}
              />
            }
            <Field
              component={ReactSelectDropdownInput}
              name="billingCodes"
              isLoading={billingCodes && billingCodes.isFetching}
              placeholder="Select Billing Code"
              options={billingOptions}
              disabled={isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked}
              noOptionsMessage="No codes found"
              getOptionLabel={p => {
                let label = p.name
                if (p.description) {
                  label += ` - ${p.description}`
                }
                return label
              }}
              getOptionValue={p => p.id}
            />
            <Field
              component={TextInput}
              placeholder="Enter EHR Order Number"
              name="orderNumber"
              disabled={isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked}
            />
          </div>
        </div>
        <div className={(isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked) ? styles.prescribeSectionGrey : styles.prescribeSection}>
          <h2>Inbox Settings</h2>
          <div className={styles.label}>Flag Patient Recordings for Review</div>
          <div className={styles.prescribeStep}>
            <span>Step</span>
            <Number3 />
          </div>
          <div className={styles.prescribeBorder}>
            <Field
              component={ReactSelectDropdownInput}
              placeholder="Which Recordings to Flag"
              name="ekgReviewWhichRecordings"
              isLoading={triggers && triggers.isFetching}
              isClearable={false}
              backspaceRemovesValue={false}
              options={triggerOptions}
              noOptionsMessage="No recording type found"
              getOptionLabel={p => p.label}
              getOptionValue={p => p.id}
            />
            {isCustomSelected &&
              (
                <div className={styles.customRules}>
                  <h3>Custom Rules</h3>
                  <Field
                    component={CheckboxInput}
                    label="Possible AFib result"
                    name="custom.possibleAFibResultCheckmark"
                  />
                  <Field
                    component={TextInput}
                    type="number"
                    inline
                    disabled={!isPossibleAFibResultWithHrCheckmarked}
                    getLabel={() => (
                      <Field
                        component={CheckboxInput}
                        className={styles.checkboxGroupFixedWidth}
                        label="Possible AFib result with heart rate over"
                        name="custom.possibleAFibResultWithHrCheckmark"
                      />
                    )}
                    name="custom.possibleAFibResultWithHr"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Sinus Rhythm with Wide QRS"
                    name="custom.sinusRhythmWithWideQRS"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Sinus Rhythm with SVE"
                    name="custom.sinusRhythmWithSVEs"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Sinus Rhythm with PVCs"
                    name="custom.sinusRhythmWithPVCs"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Tachycardia"
                    name="custom.tachycardia"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Bradycardia"
                    name="custom.bradycardia"
                  />
                  <Field
                    component={CheckboxInput}
                    label="Unclassified result"
                    name="custom.unclassifiedResultCheckmark"
                  />
                  <Field
                    component={TextInput}
                    type="number"
                    inline
                    disabled={!isHeartRateUnderCheckmarked}
                    getLabel={() => (
                      <Field
                        component={CheckboxInput}
                        className={styles.checkboxGroupFixedWidth}
                        label="Heart rate under"
                        name="custom.heartRateUnderCheckmark"
                      />
                    )}
                    name="custom.heartRateUnder"
                  />
                  <Field
                    component={TextInput}
                    type="number"
                    inline
                    disabled={!isHeartRateOverCheckmarked}
                    getLabel={() => (
                      <Field
                        component={CheckboxInput}
                        className={styles.checkboxGroupFixedWidth}
                        label="Heart rate over"
                        name="custom.heartRateOverCheckmark"
                      />
                    )}
                    name="custom.heartRateOver"
                  />
                </div>
              )
            }
            <Field
              component={ReactSelectDropdownInput}
              placeholder="Flagged Recordings Go to"
              name="ekgReviewWhereRecordings"
              isLoading={physicians && physicians.isFetching}
              isClearable={false}
              backspaceRemovesValue={false}
              options={physiciansOptions}
              noOptionsMessage="No recording location found"
              getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
              getOptionValue={p => p.id}
            />
          </div>
        </div>
        <div className={styles.prescribeSubmitWrapper}>
          <div className={styles.buttonWrapper}>
            {submitting || isSubmitting ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              <button
                type="submit"
                disabled={invalid || pristine}
                className={styles.submit}
                data-action="button-prescribe-plan"
                data-label="order"
              >
                Order
              </button>
            }
          </div>
        </div>
      </form>
    </div>
  )
}

export default reduxForm({
  form: 'prescribeForm',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(PrescribeForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/PrescribeForm.jsx